export default [
    {
        title: "Information System",
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/png-icons/cruzeiro-do-sul.png",
    },
    {
        title: "Front-End | Back-End | Mobile",
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/rocketseat.svg",
    },
    {
        title: "Business Management",
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/png-icons/euro-anglo.png",
    },
]
